import React, { useState } from 'react';

const LANG_TABS = [
  { code: 'ru', label: '🇷🇺 RU', color: '#2196F3' },
  { code: 'uz', label: '🇺🇿 UZ', color: '#4CAF50' },
  { code: 'en', label: '🇬🇧 EN', color: '#FF9800' },
];

function FillDot({ filled }) {
  return (
    <span style={{
      display: 'inline-block',
      width: '7px', height: '7px',
      borderRadius: '50%',
      backgroundColor: filled ? '#4CAF50' : '#E0E0E0',
      marginLeft: '4px',
      verticalAlign: 'middle',
    }} />
  );
}

export function TranslationsEditor({ item, onChange, enabledLanguages }) {
  const tabs = enabledLanguages?.length
    ? LANG_TABS.filter((l) => enabledLanguages.includes(l.code))
    : LANG_TABS;
  const [activeLang, setActiveLang] = useState(tabs[0]?.code || 'ru');
  const lang = tabs.find(l => l.code === activeLang);
  const nameKey = `name_${activeLang}`;
  const descKey = `description_${activeLang}`;

  return (
    <div style={{
      border: '1px solid #E8E8E8',
      borderRadius: '12px',
      overflow: 'hidden',
      marginBottom: '8px',
    }}>
      <div style={{
        padding: '8px 12px',
        backgroundColor: '#F8F8F8',
        borderBottom: '1px solid #E8E8E8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <span style={{ fontSize: '12px', color: '#666', fontWeight: '600' }}>
          🌐 Переводы
        </span>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          {tabs.map(l => (
            <span key={l.code} style={{ fontSize: '11px', color: '#999' }}>
              {l.label.split(' ')[1]}
              <FillDot filled={!!(item?.[`name_${l.code}`])} />
            </span>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid #E8E8E8' }}>
        {tabs.map(l => (
          <button
            key={l.code}
            type="button"
            onClick={() => setActiveLang(l.code)}
            style={{
              flex: 1,
              padding: '8px 4px',
              border: 'none',
              borderBottom: activeLang === l.code
                ? `2px solid ${l.color}`
                : '2px solid transparent',
              backgroundColor: 'transparent',
              fontSize: '13px',
              fontWeight: activeLang === l.code ? '700' : '400',
              color: activeLang === l.code ? l.color : '#999',
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
          >
            {l.label}
            {item?.[`name_${l.code}`] && (
              <span style={{
                display: 'inline-block',
                width: '5px', height: '5px',
                borderRadius: '50%',
                backgroundColor: l.color,
                marginLeft: '4px',
                verticalAlign: 'middle',
              }} />
            )}
          </button>
        ))}
      </div>

      <div style={{ padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <input
          style={{
            width: '100%', padding: '9px 11px',
            borderRadius: '8px',
            border: `1px solid ${item?.[nameKey] ? lang.color + '66' : '#E0E0E0'}`,
            fontSize: '14px', boxSizing: 'border-box', outline: 'none',
            backgroundColor: item?.[nameKey] ? lang.color + '08' : '#fff',
          }}
          placeholder={`Название (${activeLang.toUpperCase()})`}
          value={item?.[nameKey] || ''}
          onChange={e => onChange({ ...item, [nameKey]: e.target.value })}
        />
        <textarea
          style={{
            width: '100%', padding: '9px 11px',
            borderRadius: '8px',
            border: `1px solid ${item?.[descKey] ? lang.color + '66' : '#E0E0E0'}`,
            fontSize: '13px', boxSizing: 'border-box', outline: 'none',
            resize: 'none', height: '64px',
            backgroundColor: item?.[descKey] ? lang.color + '08' : '#fff',
          }}
          placeholder={`Описание (${activeLang.toUpperCase()}) — необязательно`}
          value={item?.[descKey] || ''}
          onChange={e => onChange({ ...item, [descKey]: e.target.value })}
        />
      </div>
    </div>
  );
}

export function CategoryTranslationsEditor({ cat, onChange, enabledLanguages }) {
  const tabs = enabledLanguages?.length
    ? LANG_TABS.filter((l) => enabledLanguages.includes(l.code))
    : LANG_TABS;
  const [activeLang, setActiveLang] = useState(tabs[0]?.code || 'ru');
  const lang = tabs.find(l => l.code === activeLang);
  const nameKey = `name_${activeLang}`;

  return (
    <div style={{
      border: '1px solid #E8E8E8',
      borderRadius: '10px',
      overflow: 'hidden',
      marginTop: '8px',
    }}>
      <div style={{ display: 'flex', borderBottom: '1px solid #E8E8E8' }}>
        {tabs.map(l => (
          <button
            key={l.code}
            type="button"
            onClick={() => setActiveLang(l.code)}
            style={{
              flex: 1, padding: '7px 4px',
              border: 'none',
              borderBottom: activeLang === l.code
                ? `2px solid ${l.color}`
                : '2px solid transparent',
              backgroundColor: 'transparent',
              fontSize: '12px',
              fontWeight: activeLang === l.code ? '700' : '400',
              color: activeLang === l.code ? l.color : '#999',
              cursor: 'pointer',
            }}
          >
            {l.label}
            {cat?.[`name_${l.code}`] && (
              <span style={{
                display: 'inline-block', width: '5px', height: '5px',
                borderRadius: '50%', backgroundColor: l.color,
                marginLeft: '4px', verticalAlign: 'middle',
              }} />
            )}
          </button>
        ))}
      </div>

      <div style={{ padding: '8px 10px' }}>
        <input
          style={{
            width: '100%', padding: '8px 10px',
            borderRadius: '8px',
            border: `1px solid ${cat?.[nameKey] ? lang.color + '66' : '#E0E0E0'}`,
            fontSize: '13px', boxSizing: 'border-box', outline: 'none',
            backgroundColor: cat?.[nameKey] ? lang.color + '08' : '#fff',
          }}
          placeholder={`Название (${activeLang.toUpperCase()})`}
          value={cat?.[nameKey] || ''}
          onChange={e => onChange({ ...cat, [nameKey]: e.target.value })}
        />
      </div>
    </div>
  );
}
